module.exports = __webpack_public_path__ + "static/img/kols1.4da5232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols1.png
// module id = nPxq
// module chunks = 0